// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { packageMetadata } from '../package-metadata';
import { getTemplate, Icon, validatePackage } from '@progress/kendo-vue-common';
/**
 * @hidden
 */
var BottomNavigationItemVue2 = {
  name: 'KendoBottomNavigationItem',
  // @ts-ignore
  emits: {
    'keydown': null,
    'select': null
  },
  props: {
    id: String,
    disabled: Boolean,
    selected: Boolean,
    icon: String,
    item: [String, Object, Function],
    text: String,
    dataItem: Object,
    index: Number,
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
  },
  computed: {
    itemClasses: function itemClasses() {
      var _a = this.$props,
        selected = _a.selected,
        disabled = _a.disabled;
      return {
        'k-bottom-nav-item': true,
        'k-selected': selected,
        'k-disabled': disabled
      };
    }
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
      selected = _a.selected,
      disabled = _a.disabled,
      item = _a.item,
      dataItem = _a.dataItem,
      id = _a.id,
      index = _a.index,
      tabIndex = _a.tabIndex;
    var icon = dataItem.icon,
      text = dataItem.text,
      svgIcon = dataItem.svgIcon;
    var content = getTemplate.call(this, {
      h: h,
      template: item,
      defaultRendering: null,
      additionalProps: {
        itemIndex: index,
        item: dataItem
      }
    });
    var bottomNavItem = h("span", {
      "class": this.itemClasses,
      role: 'link',
      attrs: this.v3 ? undefined : {
        role: 'link',
        id: id,
        tabIndex: tabIndex,
        "aria-current": selected,
        "aria-disabled": disabled
      },
      id: id,
      tabIndex: tabIndex,
      onClick: this.handleClick,
      on: this.v3 ? undefined : {
        "click": this.handleClick,
        "keydown": this.handleKeyDown
      },
      onKeydown: this.handleKeyDown,
      "aria-current": selected,
      "aria-disabled": disabled
    }, [this.$props.item ? content : [icon && h(Icon, {
      name: icon,
      attrs: this.v3 ? undefined : {
        name: icon,
        icon: svgIcon,
        size: 'xlarge'
      },
      icon: svgIcon,
      size: 'xlarge',
      "class": "k-bottom-nav-item-icon"
    }), text && h("span", {
      "class": 'k-bottom-nav-item-text',
      style: {
        userSelect: 'none'
      }
    }, [text])]]);
    return bottomNavItem;
  },
  methods: {
    handleClick: function handleClick(event) {
      if (this.index !== undefined && !this.disabled) {
        this.$emit('select', event, this.index);
      }
    },
    handleKeyDown: function handleKeyDown(event) {
      if (this.index !== undefined && !this.disabled) {
        this.$emit('keydown', event, this.index);
      }
    }
  }
};
/**
 * @hidden
 */
var BottomNavigationItem = BottomNavigationItemVue2;
export { BottomNavigationItem, BottomNavigationItemVue2 };